// extracted by mini-css-extract-plugin
export default {"home":"ProjectListPage-styles-module--home--jT446"};